// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UploadProjectFormSuccess_wrapper___f3JI","wrapperTitle":"UploadProjectFormSuccess_wrapperTitle__bm_ed","wrapperContent":"UploadProjectFormSuccess_wrapperContent__5fqZr"};